import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommMyLocationIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <g clipPath="url(#clip0_15733_3417)">
            <path
              d="M12 0.75C12.4142 0.75 12.75 1.08579 12.75 1.5V2.77888C17.2669 3.13461 20.8714 6.73494 21.2337 11.25H22.5C22.9142 11.25 23.25 11.5858 23.25 12C23.25 12.4142 22.9142 12.75 22.5 12.75H21.2337C20.8714 17.2651 17.2669 20.8654 12.75 21.2211V22.5C12.75 22.9142 12.4142 23.25 12 23.25C11.5858 23.25 11.25 22.9142 11.25 22.5V21.2189C6.7459 20.8508 3.15519 17.2559 2.79364 12.75H1.5C1.08579 12.75 0.75 12.4142 0.75 12C0.75 11.5858 1.08579 11.25 1.5 11.25H2.79364C3.15519 6.74405 6.7459 3.14915 11.25 2.78107V1.5C11.25 1.08579 11.5858 0.75 12 0.75ZM19.7625 11.863C19.7543 11.9074 19.75 11.9532 19.75 12C19.75 12.0468 19.7543 12.0926 19.7625 12.137C19.6894 16.354 16.2481 19.75 12.0137 19.75C7.73347 19.75 4.26367 16.2802 4.26367 12C4.26367 7.71979 7.73347 4.25 12.0137 4.25C16.2481 4.25 19.6894 7.646 19.7625 11.863ZM12 9.75C10.7573 9.75 9.74995 10.7574 9.74995 12C9.74995 13.2426 10.7573 14.25 12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75ZM8.24995 12C8.24995 9.92893 9.92889 8.25 12 8.25C14.071 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.071 15.75 12 15.75C9.92889 15.75 8.24995 14.0711 8.24995 12Z"
              fill="#222"
              fillRule="evenodd"
              clipRule="evenodd"
            />
          </g>
          <defs>
            <clipPath id="clip0_15733_3417">
              <path fill="#fff" d="M0 0H24V24H0z" />
            </clipPath>
          </defs>
        </svg>
      </IconWrapper>
    )
  },
)
